import React, { useRef } from 'react';
import {
  Panel,
  PanelHeader,
  PanelContent,
  PanelFooter,
  PanelFooterColumn,
} from '@flixbus/honeycomb-react';
import { useTranslations } from 'app/hooks/useTranslations';
import { a11yLabelsKeys } from 'app/providers/a11yLabels';
import { ProductPanelType } from 'app/models/types/store/ui';
import styles from './ProductMobilePanel.scss';
import { useDispatch, useSelector } from 'react-redux';
import { openedOverlaySelector } from 'app/store/selectors';
import { toggleOverlay } from 'app/store/actions';
import { ProductPopupContent } from 'app/components/product/ProductPopupContent/ProductPopupContent';
import { ConfirmButton } from 'app/components/ui/ConfirmButton/ConfirmButton';
import { tabTrap } from 'app/providers/tabTrap';

export const ProductMobilePanel = () => {
  const { getCloseLabel, getTitle } = useTranslations({
    getCloseLabel: a11yLabelsKeys.close,
    getTitle: 'search_bundle.search_widget.passengers',
  });
  const overlayData = useSelector(openedOverlaySelector) || ({} as ProductPanelType);
  const { name, props } = overlayData as ProductPanelType;
  const { handleClose } = props || {};
  const wrapperRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();

  const onClose = () => {
    if (handleClose) {
      handleClose();
    }
    dispatch(toggleOverlay({ name: 'ProductPanel' }));
  };

  const isActive = name === 'ProductPanel' && !!props;
  if (!isActive) {
    return null;
  }

  const tabTrapAction = (e: React.KeyboardEvent) =>
    tabTrap({
      event: e,
      firstItemSelector: '#close-button',
      lastItemSelector: '#confirm-button',
      isActive,
      wrapper: wrapperRef.current,
    });
  return (
    <div ref={wrapperRef}>
      <Panel
        id="mobile-panel"
        extraClasses={styles.panelWrapper}
        active={isActive}
        position="bottom"
        fullSize
        hasOverlay
        onOverlayClick={onClose}
      >
        <PanelHeader
          closeButtonProps={{
            label: getCloseLabel(),
            onClick: onClose,
            onKeyDown: tabTrapAction,
            id: 'close-button',
          }}
          extraClasses={styles.panelHeader}
        >
          {getTitle()}
        </PanelHeader>
        <PanelContent extraClasses={styles.panelContent}>
          <ProductPopupContent {...props} />
        </PanelContent>
        <PanelFooter extraClasses={styles.panelFooter}>
          <PanelFooterColumn>
            <ConfirmButton id="confirm-button" onClick={onClose} onKeyDown={tabTrapAction} />
          </PanelFooterColumn>
        </PanelFooter>
      </Panel>
    </div>
  );
};
